import React, { Component } from 'react';
import { connect } from 'react-redux'
import { parsedUrl } from '../../services/url';

import { BOOXI_QUERY_PARAMETER } from '../../settings/booxi';

import { booxiIsLoaded, openBooxi } from '../../services/booxi';
import { countryCode, language, locale } from '../../services/translator';

import {
  changeTravelMode,
  closeItineraryDetails,
  fetchItinerary,
  openItineraryDetails,
  selectPointOfSale,
  setCurrentAddress,
  setPanel,
  toggleItinerary
} from '../../actions/pointOfSale';

import {
  togglePopinAppointment,
  togglePopinShare
} from '../../actions/popin';

import Itinerary from 'ui-kit/src/components/Itinerary/Itinerary';
import ItineraryPanel from 'ui-kit/src/components/ItineraryPanel/ItineraryPanel';
import ShopBlock from 'ui-kit/src/components/ShopBlock/ShopBlock';

let mounted = false;

class StatefulShopBlock extends Component {
  componentDidMount() {
    const booxiId = parsedUrl.query[BOOXI_QUERY_PARAMETER];
    if (booxiId && this.props.shop.id === booxiId && !mounted) {
      openBooxi(this.props.shop.apiKeyBooxi);
      mounted = true;
    }
  }

  calendarCallback() {
    if (this.props.shop.apiKeyBooxi && booxiIsLoaded()) {
      openBooxi(this.props.shop.apiKeyBooxi);
    } else {
      this.props.calendarCallback(this.props.shop.id);
    }
  }

  formatDistance(distance) {
    if (distance) {
      return parseInt(distance * 10, 10) / 10 + 'km';
    }
  }

  printCallback() {
    window.print();
  }

  render() {
    const isSelected = this.props.selectedId === this.props.shop.id;
    const itineraryState = !isSelected || !this.props.isItineraryVisible;

    return (
      <ShopBlock
        api={this.props.api}
        calendarCallback={this.calendarCallback.bind(this)}
        departure={this.props.currentAddress}
        displayType={this.props.displayType}
        distance={this.formatDistance(this.props.shop.distance)}
        isItineraryVisible={this.props.isItineraryVisible && isSelected}
        isSelected={isSelected}
        itineraryCallback={this.props.toggleItinerary.bind(null, this.props.shop.id, itineraryState)}
        number={this.props.label}
        shareCallback={this.props.shareCallback.bind(null, this.props.shop.id)}
        shop={this.props.shop}
        triggerCallback={this.props.selectPointOfSale.bind(null, this.props.shop.id)}
        countryCode={countryCode}
        locale={locale}
        lang={language}
      >
        {isSelected && this.props.displayItinerary && (
          <div>
            <Itinerary
              api={this.props.api}
              changeTravelModeCallback={this.props.changeTravelMode}
              countryCode={countryCode}
              departure={this.props.currentAddress}
              detailsCallback={this.props.openItineraryDetails}
              isGeolocationAvailable={this.props.isGeolocationAvailable}
              isItineraryDetailsOpen={this.props.isItineraryDetailsOpen}
              map={this.props.map}
              panel={this.props.panel}
              setCurrentAddress={this.props.setCurrentAddress}
              shop={this.props.shop}
              submitCallback={this.props.fetchItinerary}
              travelMode={this.props.travelMode}
            />
            <ItineraryPanel
              id={this.props.shop.id}
              closeCallback={this.props.closeItineraryDetails}
              isOpen={this.props.isItineraryDetailsOpen}
              itinerary={this.props.itinerary}
              setPanel={this.props.setPanel}
              travelMode={this.props.travelMode}
              printCallback={this.printCallback.bind(this)}
            />
          </div>
        )}
      </ShopBlock>
    );
  }
}

const mapStateToProps = (state) => {
  return  {
    api: state.pointOfSale.api,
    currentAddress: state.pointOfSale.currentAddress,
    displayType: state.shared.displayType,
    isItineraryVisible: state.pointOfSale.isItineraryVisible,
    isItineraryDetailsOpen: state.pointOfSale.isItineraryDetailsOpen,
    isGeolocationAvailable: state.shared.isGeolocationAvailable,
    itinerary: state.pointOfSale.itinerary,
    map: state.pointOfSale.map,
    panel: state.pointOfSale.panel,
    selectedId: state.pointOfSale.selectedId,
    setPanel: state.pointOfSale.setPanel,
    travelMode: state.pointOfSale.travelMode
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    calendarCallback: togglePopinAppointment.bind(null, dispatch, true),
    changeTravelMode: changeTravelMode.bind(null, dispatch),
    closeItineraryDetails: closeItineraryDetails.bind(null, dispatch),
    fetchItinerary: fetchItinerary.bind(null, dispatch),
    openItineraryDetails: openItineraryDetails.bind(null, dispatch),
    selectPointOfSale: selectPointOfSale.bind(null, dispatch),
    setCurrentAddress: setCurrentAddress.bind(null, dispatch),
    setPanel: setPanel.bind(null, dispatch),
    shareCallback: togglePopinShare.bind(null, dispatch, true),
    toggleItinerary: toggleItinerary.bind(null, dispatch)
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(StatefulShopBlock);



// WEBPACK FOOTER //
// ./src/components/StatefulShopBlock/StatefulShopBlock.jsx